
/* ---- scroll trigger ---- */

ScrollTrigger.matchMedia({
	
 // desktop
  "(min-width: 1025px)": function() {

gsap.registerPlugin(ScrollTrigger);

gsap.to(".panel:not(:last-child)", {
  yPercent: -110, 
  ease: "none",
  stagger: 0.5,
  scrollTrigger: {
    trigger: ".ced-collection-list",
    start: "top top",
    end: "+=100%",
    scrub: true,
    pin: true
  }
});

gsap.set(".panel", {zIndex: (i, target, targets) => targets.length - i});   

},
  
   // mobile
  "(max-width: 1024px)": function() {
    return function() {
      gsap.kill(); 
      // other cleanup code can go here. 
    };
  }
  
});



